// src/LoginPage.js

import React, { useState } from "react";
import { TextField, Button, Box } from "@mui/material";
import { signInWithEmailAndPassword } from "firebase/auth";

import { useNavigate } from "react-router-dom";

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      await signInWithEmailAndPassword(email, password);
      navigate("/admin"); // Redirigir al panel de administración
    } catch (error) {
      alert("Error al iniciar sesión: " + error.message);
    }
  };

  return (
    <Box>
      <TextField
        label="Correo electrónico"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Contraseña"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        fullWidth
        margin="normal"
      />
      <Button onClick={handleLogin} variant="contained" fullWidth>
        Iniciar sesión
      </Button>
    </Box>
  );
}

export default LoginPage;
